import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import { createTheme, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

export default function FormDialog({
  classes,
  MenuProps,
  getStyles,
  theme,
  listOfequipmentIDs,
  handleMultipleEquipmentID,
  handleClear,
  selectedIDs,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const useStyles = makeStyles(() => ({
    paper: { minWidth: '500px' },
  }));

  let body = (
    <Dialog
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>
        Advance Filtering Options
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Feature still in Development</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
  body = (
    <Dialog
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>Filter By ID</DialogTitle>

      <DialogContent>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'left',
              backgroundColor: '#dddddd',
              padding: '8px',
              borderRadius: '8px',
            }}
            item
            xs={12}>
            <span style={{ fontSize: '1.2em' }}>Equipment ID</span>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '8px',
            }}
            item
            xs={12}>
            <FormControl
              style={{ minWidth: 120 }}
              className={classes.formControl}>
              <InputLabel id='demo-mutiple-chip-label'>Equipment ID</InputLabel>
              <Select
                labelId='demo-mutiple-chip-label'
                id='demo-mutiple-chip'
                multiple
                value={selectedIDs}
                onChange={handleMultipleEquipmentID}
                input={<Input id='select-multiple-chip' />}
                renderValue={(selected) => (
                  <div>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}>
                {listOfequipmentIDs.map((ids) => (
                  <MenuItem
                    key={ids}
                    value={ids}
                    style={getStyles(ids, selectedIDs, theme)}>
                    {ids}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Back
        </Button>
        <Button onClick={handleClear} color='primary'>
          Clear
        </Button>
      </DialogActions>
    </Dialog>
  );

  // return { body };
  return (
    <div>
      <span
        onClick={handleClickOpen}
        // onMouseLeave={handleDropDownClose}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
        <HorizontalSplitIcon color={'primary'} fontSize={'small'} />
        &nbsp; &nbsp;
        <span
          style={{
            fontFamily: 'Roboto',
            fontWeight: '500',
            fontSize: '0.8125rem',
            color: '#26477c',
          }}>
          FILTER OPTIONS
        </span>
      </span>
      {body}
    </div>
  );
}
